import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import {
  FaEllipsisV,
  FaSignOutAlt,
  FaUpload,
  FaCogs,
  FaUserShield,
} from "react-icons/fa";
import "./UserOptionsMenu.css";

const UserOptionsMenu = ({ onLogout }) => {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      onLogout();
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  const handleUploadTemplate = () => {
    navigate("/upload-template");
  };

  const handleManageTemplates = () => {
    console.log("Manage Templates clicked");
    // TODO: Implement template management functionality
  };

  const handleAdminLogin = () => {
    navigate("/admin-login");
  };

  return (
    <div className="user-options-menu">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button className="menu-trigger" aria-label="User options">
            <FaEllipsisV size={24} />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content className="menu-content" sideOffset={5}>
            <DropdownMenu.Item className="menu-item" onSelect={handleLogout}>
              <FaSignOutAlt className="menu-icon" />
              <span>Logout</span>
            </DropdownMenu.Item>

            <DropdownMenu.Item
              className="menu-item"
              onSelect={handleUploadTemplate}
            >
              <FaUpload className="menu-icon" />
              <span>Upload Template</span>
            </DropdownMenu.Item>

            <DropdownMenu.Item
              className="menu-item"
              onSelect={handleManageTemplates}
            >
              <FaCogs className="menu-icon" />
              <span>Manage Templates</span>
            </DropdownMenu.Item>

            <DropdownMenu.Separator className="menu-separator" />

            <DropdownMenu.Item
              className="menu-item menu-item-admin"
              onSelect={handleAdminLogin}
            >
              <FaUserShield className="menu-icon" />
              <span>Admin Login</span>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
};

export default UserOptionsMenu;
